const CONSTANTS = {
    // training
    ON_HISTORICAL_LIST_IS_LOADING: 'training/ON_HISTORICAL_LIST_IS_LOADING',
    ON_HISTORICAL_LIST: 'training/ON_HISTORICAL_LIST',
    ON_ASSISTANT_LIST_IS_LOADING: 'training/ON_ASSISTANT_LIST_IS_LOADING',
    ON_ASSISTANT_LIST: 'training/ON_ASSISTANT_LIST',
    ON_TOGGLE_SELECT_ITEM: 'training/ON_TOGGLE_SELECT_ITEM',
    ON_CLEAR_SELECTION: 'training/ON_CLEAR_SELECTION',
    ON_ZOOM_SELECTION: 'training/ON_ZOOM_SELECTION'
};

export { CONSTANTS };
